/* eslint-disable react/prop-types */
// layouts/catalogos/generos/datageneros.js

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import { ui } from "ui/tokens";

export const columns = [
  { name: "genero", align: "left", sortable: true },
  { name: "creado", align: "center", sortable: true },
  { name: "action", align: "center" },
];

const formatDate = (d) => {
  if (!d) return "-";
  try {
    const dt = new Date(d);
    if (Number.isNaN(dt.getTime())) return d;
    const dd = String(dt.getDate()).padStart(2, "0");
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const yy = String(dt.getFullYear()).slice(-2);
    return `${dd}/${mm}/${yy}`;
  } catch { return d; }
};

export default function buildGenerosTableData(items = [], adapter) {
  const rows = (items || []).map((raw, idx) => {
    const g = adapter
      ? adapter(raw, idx)
      : {
          id: raw.id ?? raw._id ?? idx,
          nombre: raw.name ?? raw.nombre ?? "-",
          creado: raw.created_at ?? raw.createdAt,
          onEdit: () => {},
          onDelete: () => {},
        };

    return {
      genero: (
        <SoftBox display="flex" flexDirection="column">
          <SoftTypography variant="button" fontWeight="medium">{g.nombre}</SoftTypography>
        </SoftBox>
      ),
      creado: (
        <SoftTypography variant="caption" color="secondary" fontWeight="medium">
          {formatDate(g.creado)}
        </SoftTypography>
      ),
      action: (
        <SoftBox display="flex" gap={0.5} justifyContent="center">
          <Tooltip title="Editar">
            <IconButton
              size="small"
              onClick={(e) => { e.preventDefault(); g.onEdit?.(g); }}
              sx={{
                "& .icon-edit": { color: ui.icon?.edit?.base || "#0ea5e9" },
                "&:hover .icon-edit": { color: ui.icon?.edit?.hover || "#0284c7" },
                transition: "transform .15s ease",
                "&:hover": { transform: "scale(1.12)" },
              }}
            >
              <Icon className="icon-edit" fontSize="small">edit</Icon>
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar">
            <IconButton
              size="small"
              onClick={(e) => { e.preventDefault(); g.onDelete?.(g); }}
              sx={{
                "& .icon-del": { color: ui.icon?.del?.base || "#ef4444" },
                "&:hover .icon-del": { color: ui.icon?.del?.hover || "#b91c1c" },
                transition: "transform .15s ease",
                "&:hover": { transform: "scale(1.12)" },
              }}
            >
              <Icon className="icon-del" fontSize="small">delete</Icon>
            </IconButton>
          </Tooltip>
        </SoftBox>
      ),
    };
  });

  return { columns, rows };
}
